import gql from 'graphql-tag'

export const queryContractByPk = id => {
	return {
		query: gql`
			query ($id: bigint!) {
				contract: contracts_by_pk(id: $id) {
					applicant_name
					applicant_email
					contract_category
					recommended
					contract_type
					comercial_base
					comercial_category_id
					organization_id
					delegation
					responsable
					team
					contract_retention
					contracts_campaigns {
						campaign_id
					}
					name
					document
					domicilio
					zipcode
					poblacion
					cellphone
					phone
					email
					contact_person
					contact_admon
					iban
					representant_nif
					representant_type
					signature_type
					contracts_files {
						id
						file_url
					}
					status
					signature_nop
					ahorreluz_code
					delivery_address
					business_name
					objective
				}
			}
		`,
		update(data) {
			return {
				applicant_name: data.contract.applicant_name,
				applicant_email: data.contract.applicant_email,
				signature_nop: data.contract.signature_nop,
				name: data.contract.name,
				phone: data.contract.phone,
				email: data.contract.email,
				contract_type: data.contract.contract_type,
				status: data.contract.status,
				document: data.contract.document,
				signature_type: data.contract.signature_type,
				organization_id: data.contract.organization_id,
				comercial_base: data.contract.comercial_base,
				delegation_id: data.contract.delegation,
				responsable_id: data.contract.responsable,
				zipcode: data.contract.zipcode,
				domicilio: data.contract.domicilio,
				poblacion: data.contract.poblacion,
				cellphone: data.contract.cellphone,
				contact_person: data.contract.contact_person,
				contact_admon: data.contract.contact_admon,
				iban: data.contract.iban,
				retention_id: data.contract.contract_retention,
				representant_nif: data.contract.representant_nif,
				representant_type: data.contract.representant_type,
				team: data.contract.team,
				comercial_category_id: data.contract.comercial_category_id,
				contract_category: data.contract.contract_category,
				recommended: data.contract.recommended,
				comments: data.contract.comments,
				campaigns: data.contract.contracts_campaigns.map(elem => ({
					id: elem.campaign_id,
				})),
				files: data.contract.contracts_files.map(c => ({
					name: c.file_url,
				})),
				ahorreluz_code: data.contract.ahorreluz_code,
				delivery_address: data.contract.delivery_address,
				business_name: data.contract.business_name,
				objective: data.contract.objective,
			}
		},
		variables: {
			id: parseInt(id),
		},
	}
}
